import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbButtonModule,
  NbCardModule,
  NbDialogModule,
  NbIconModule,
  NbSpinnerModule,
  NbTooltipModule,
} from '@nebular/theme';
import { RouterModule } from '@angular/router';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { ComponentsModule } from 'src/app/components/components.module';
import { ResourceArtifactHistoryRoutingModule } from './resource-artifact-history-routing.module';
import { ResourceArtifactHistoryComponent } from './resource-artifact-history.component';

@NgModule({
  declarations: [ResourceArtifactHistoryComponent],
  imports: [
    CommonModule,
    RouterModule,
    NbCardModule,
    Ng2SmartTableModule,
    NbIconModule,
    NbEvaIconsModule,
    NbDialogModule,
    NbButtonModule,
    NbButtonModule,
    NbTooltipModule,
    NbSpinnerModule,
    ComponentsModule,
    ResourceArtifactHistoryRoutingModule,
  ],
  exports: [ResourceArtifactHistoryComponent],
})
export class ResourceArtifactHistoryModule {}
